import {createRoot} from "react-dom/client";
import * as React from "react";
import RatingStars from "../lib/ratingStars/RatingStars";
import ContainerHead from "../molecules/ContainerHead";
import SwiperElement from "../molecules/SwiperElement";

class ProductLists {
  // Top Categories Swiper Parameters
  private static swiperParams = {
    navigation: {
      nextEl: ".product-lists .swiper-btn-next",
      prevEl: ".product-lists .swiper-btn-prev",
    },
    slidesOffsetBefore: 16,
    slidesOffsetAfter: 16,
    slidesPerView: 2.5,
    breakpoints: {
      481: {
        slidesPerView: 2.4,
      },
      651: {
        slidesPerView: 2.6,
      },
      768: {
        slidesPerView: 4.5,
      },
      851: {
        slidesPerView: 3.5,
      },
      941: {
        slidesOffsetBefore: 16,
        slidesOffsetAfter: 16,
        slidesPerView: 3.66,
        rewind: true,
      },
      1132: {
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        slidesPerView: 4,
        rewind: true,
      },
    },
    on: {
      init: (swiper: {slides: HTMLElement[]}) => {
        swiper.slides.forEach((slide) => {
          const ratingParagraph = slide.querySelector<HTMLElement>(".product-lists__item-rating");
          if (ratingParagraph) {
            const ratingValue = ratingParagraph.dataset.itemRating;
            const root = createRoot(ratingParagraph);
            root.render(React.createElement(RatingStars, {rating: Number(ratingValue)}));
          }
        });
      },
    },
  };

  public static run(section: HTMLElement): void {
    const containerHead: HTMLElement | null = section.querySelector(".react-container-head");
    if (containerHead) {
      new ContainerHead(containerHead);
    }

    const navigationButtons: HTMLElement | null = section.querySelector(".swiper-navigation");
    if (navigationButtons !== null) {
      navigationButtons.style.display = "";
    }

    SwiperElement.run(section, ProductLists.swiperParams);
  }
}

export default ProductLists;
